import React from "react";
import { useRouter } from "next/router";
import { JhButton } from "designPackages/buttonPackage";
import { checkChromeExtensionInstalled } from "services/utilsv2";
import { waBroadCastExtensionId } from "services/waBroadCastConstants";
import { Routes } from "routes/RouteConstants";
import useModalStore from "zustandStores/useModalStore";
import { modalStateValues, modalType } from "services/constants";

const BulkWhatsAppCTA: React.FC = () => {
  const router = useRouter();
  const { setModalData } = useModalStore(state => ({
    setModalData: state.setModalData
  }));

  const handleBulkWhatsAppClick = async () => {
    try {
      const isChromeExtensionInstalled = await checkChromeExtensionInstalled(
        waBroadCastExtensionId
      );

      if (isChromeExtensionInstalled) {
        // Open the bulk WhatsApp jobs modal
        setModalData({
          state: modalStateValues.open,
          type: modalType.BULK_WHATSAPP_JOBS_MODAL
        });
      } else {
        // If extension is not installed, navigate to WhatsApp broadcast page
        await router.push(Routes.WHATSAPP_BROADCAST);
      }
    } catch (error) {
      console.error("Error in handleBulkWhatsAppClick:", error);
      // Error handling is done - router.push and checkChromeExtensionInstalled errors are handled
    }
  };

  return (
    <JhButton variant="default" size="sm" onClick={handleBulkWhatsAppClick}>
      Send Bulk Messages
    </JhButton>
  );
};

export default BulkWhatsAppCTA;
